import { createUser, getTenant } from "../api";
import {
  Title,
  TextInput,
  Button,
  Container,
  Alert,
  Loader,
  Center,
  Text,
  Group,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useState, useEffect } from "react";
import { useLocation } from "wouter";

export default function TenantUserCreate({ params }) {
  const [, setLocation] = useLocation();
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    getTenant(params.tenantId).then((data) => setTenant(data));
  }, [params.tenantId]);

  const form = useForm({
    initialValues: {
      emailAddress: "",
      tenantId: params.tenantId,
    },
    validate: {
      emailAddress: (val) => (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(val) ? null : "Invalid email"),
    },
  });

  if (!tenant)
    return (
      <Center>
        <Loader mt="xl" size="xl" />
      </Center>
    );

  return (
    <Container size="sm">
      <Title mb="lg" order={1}>
        Create Users
      </Title>

      <Alert mb="sm">
        <Text>Tenant ID: {tenant.id}</Text>
        <Text>Tenant name: {tenant.name}</Text>
      </Alert>

      <Alert mb="sm">TBD: Textfield or allow CSV upload for multi-create</Alert>

      <form
        onSubmit={form.onSubmit((values) => {
          createUser(values).then((data) => {
            console.log(data);
            setLocation("/admin/users");
          });
        })}
      >
        <Group align="flex-start">
          <TextInput
            label="Admin Email"
            placeholder="management@peterfdrucker.com"
            style={{ flex: 1 }}
            {...form.getInputProps("emailAddress")}
            key={form.key("emailAddress")}
            radius="md"
          />
          <Select
            label="Role"
            data={["TenantUser", "TenantAdmin"]}
            {...form.getInputProps("role")}
            key={form.key("role")}
          />
        </Group>
        <Group justify="flex-end">
          <Button mt="md" type="submit">
            Create
          </Button>
        </Group>
      </form>
    </Container>
  );
}
